import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { convertDateToMaskTimezone } from '@app/shared/utils';
import { Observable } from 'rxjs';
import { ConfigService, TokenService } from 'viggo-sistemas-core-web';
import { IDashboard } from '../model/dashboard.model';

@Injectable()
export class DashboardService {
  constructor(
    protected http: HttpClient,
    protected configService: ConfigService,
    protected tokenService: TokenService
  ) {}

  private getHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    if (this.tokenService.getToken())
      headers = headers.append('token', this.tokenService.getToken().id);
    return headers;
  }

  /**
   * Filtro inicial colocando faixa de datas do primeiro dia ate o ultimo dia do mês
   * @returns
   */
  public getValuesDashboard(): Observable<IDashboard> {
    let url = `${this.configService.backendURL}dashboards`;
    const headers = this.getHeaders();
    var date = new Date();
    let params = new HttpParams();

    var primeiroDiaDoMes = new Date(date.getFullYear(),date.getMonth(),1);
    const primeiroDia = convertDateToMaskTimezone(primeiroDiaDoMes.getFullYear() + '-' + (primeiroDiaDoMes.getMonth() + 1) + '-' + primeiroDiaDoMes.getDate());
    const ultimoDia = convertDateToMaskTimezone(date);

    params = params.set('de', primeiroDia);
    params = params.set('ate', ultimoDia);
    return this.http.get<IDashboard>(url, { headers, params });
  }

  /**
   * Captura o valor da faixa de datas (De - Até)
   */
  public filtrarPorDatas(de: string, ate: string) {
    const headers = this.getHeaders();

    let url = `${this.configService.backendURL}dashboards`;
    let params = new HttpParams();

    params = params.set('de', de);
    params = params.set('ate', ate);

    return this.http.get<IDashboard>(url, { headers, params });
  }
}
